// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"798":"8477ce8d6ca7a796","814":"8477ce8d6ca7a796","888":"91740a356cd122a0"}[chunkId] + ".css";
};